import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import style from "./style.vue";

export const defaultImg = "https://ssl-picture.tenyun.runsasoft.com/2d97c9b0-83ab-11ea-b0d5-8b89156e3a17";
@Component({
	components: {},
	mixins: [style],
})
export default class LabelClass extends Vue {
	@Prop({ default: () => {} })
	value: NewDisplayLabClass;

	// 1 2 3白背景 4 5 6 黑背景
	@Prop()
	themeCode: number;

	@Prop()
	fontColor: string;

	get backGround() {
		return this.themeCode > 3 ? "#222222" : "#f9f9f9";
	}

	render(h) {
		const classList = (this.value.desc.list || []).filter((v) => v.isAllClass != 1);
		return (
			<div class="label-class" style={`color: ${this.fontColor};background: ${this.backGround}`}>
				{this.value.desc.showClassType === 1 ? (
					<ul>
						{classList.map((i) => {
							return (
								<li>
									<div class="img-wrap">
										<img src={i.classPic || defaultImg} alt="" srcset="" class="title-img" />
									</div>
									<p class="title">{i.className}</p>
								</li>
							);
						})}
					</ul>
				) : (
					<ul>
						<li>
							<div class="img-wrap">
								<img src={defaultImg} alt="" srcset="" class="title-img" />
							</div>
							<p class="title">标题1</p>
						</li>
						<li>
							<div class="img-wrap">
								<img src={defaultImg} alt="" srcset="" class="title-img" />
							</div>
							<p class="title">标题2</p>
						</li>
						<li>
							<div class="img-wrap">
								<img src={defaultImg} alt="" srcset="" class="title-img" />
							</div>
							<p class="title">标题3</p>
						</li>
						<li>
							<div class="img-wrap">
								<img src={defaultImg} alt="" srcset="" class="title-img" />
							</div>
							<p class="title">全部</p>
						</li>
					</ul>
				)}
			</div>
		);
	}
}
